// extracted by mini-css-extract-plugin
module.exports = {"progress":"progress_progress__eehQ_","svg":"progress_svg__3csfu","textdiv":"progress_textdiv__2kKw9"};